var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgSuccess = function SvgSuccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFF",
    d: "M8.001 1.333a6.667 6.667 0 100 13.334 6.667 6.667 0 100-13.334z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.334 8a6.67 6.67 0 016.667-6.667A6.669 6.669 0 0114.667 8a6.669 6.669 0 01-6.666 6.667A6.67 6.67 0 011.334 8zm2.467.467l2.393 2.393c.26.26.687.26.94 0l5.06-5.06a.664.664 0 10-.94-.94L6.667 9.447l-1.926-1.92a.664.664 0 10-.94.94z",
    fill: "#2AAC5E"
  })));
};
export default SvgSuccess;